import {SiteBean, SiteControllerApi} from 'api/base/api'
import {configuration} from 'api/utils/apiConfiguration'
import {customFetch} from 'api/utils/customFetch'

class SiteApi {
  api = new SiteControllerApi(configuration, configuration.basePath, customFetch)

  createSite(form: SiteBean) {
    return this.api.createSite(form)
  }

  updateSite(id: number, bean: SiteBean) {
    return this.api.updateSite(bean, id)
  }

  archive(id: number) {
    return this.api.archiveSite(id)
  }

  getSite(id: number) {
    return this.api.getSite(id)
  }

  getSiteList({ name, domain, status, orderBy, order }: ListFilters, page: number, pageSize: number) {
    return this.api.listSiteSearch(name, domain, status, orderBy, order, {
      query: { size: pageSize, page },
    })
  }

  getAllByAccount() {
    return this.api.listSiteAll()
  }
}

export interface ListFilters {
  name?: string
  domain?: string
  status: string[]
  orderBy?: 'name' | 'domain' | 'status' | 'lastStatsTime'
  order: 'ascend' | 'descend'
}

export const siteApi = new SiteApi()
